const composeQueries = (url, objects) => {
	for (const key in objects) {
		if (objects[key] === null || objects[key] === undefined) {
			delete objects[key];
		}
	}
	const queries =
		Object.keys(objects)?.length > 0
			? Object.keys(objects)
					.filter((key) => objects[key]?.toString())
					.map((key) => key + '=' + objects[key])
					.join('&')
			: undefined;
	return queries ? url + '&' + queries : url;
};

export default composeQueries;
